/* Intercepts requests to handle unauthorized/forbidden responses */

import Auth from '../auth/auth';
import history from '../history';
import { NavigationLinks } from '../common/navigation';

export const authInterceptor = ({ dispatch }) => next => action => {    
    if (action.type !== '@@query/REQUEST_FAILURE') { return next(action); }

    const status = action.status;

    if (status === 401) {
        const auth = new Auth();
        auth.logout(auth.getCurrentViewPath());
        return;
    }

    if (status === 403) {
        const actionUrl: string =
            action.url ||
            action.requestUrl ||
            (action.request && action.request.url) ||
            (action.meta && action.meta.url) ||
            '';

        const currentPath = window.location && window.location.pathname ? window.location.pathname : '';
        const relatesToRegionalComponentLists =
            (typeof actionUrl === 'string' && actionUrl.indexOf('regionalcomponentlist') >= 0) ||
            (typeof currentPath === 'string' && currentPath.indexOf('/regional-component-list') >= 0);

        if (relatesToRegionalComponentLists) {
            // Roles can change server-side; refresh cached roles so menu/route guards update quickly.
            const auth = new Auth();
            auth.refreshSessionRolesFromApi();
            history.push(NavigationLinks.userDashboard());
            return;
        }
    }

    return next(action);
};



// WEBPACK FOOTER //
// ./src/middleware/authInterceptor.tsx